import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Tag from '../../../components/atoms/Tag';
import css from './FeedbackChips.css';

const FeedbackChips = ({ reasonKeys, selectedReasonKeys, translationPrefix, onToggle }) => (
    <div className={css.chips}>
        {reasonKeys.map(reasonKey => {
            const isSelected = selectedReasonKeys.includes(reasonKey);
            return (
                <Tag
                    key={reasonKey}
                    value={`${translationPrefix}.${reasonKey}`}
                    shouldTranslate
                    isFadingBackground={false}
                    className={classNames(css.chip, { [css.chipSelected]: isSelected })}
                    onClick={() => onToggle(reasonKey)}
                />
            );
        })}
    </div>
);

FeedbackChips.propTypes = {
    reasonKeys: PropTypes.arrayOf(PropTypes.string).isRequired,
    selectedReasonKeys: PropTypes.arrayOf(PropTypes.string).isRequired,
    translationPrefix: PropTypes.string.isRequired,
    onToggle: PropTypes.func.isRequired,
};

export default FeedbackChips;